import { Formik } from 'formik';
import React, { memo, useState } from 'react';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import './Form.css';
import { postWeeding1ResultMessage } from '../../../store/slices/Wedding1ResultMessageSlice/Wedding1ResultMessageApi';
import { useDispatch, useSelector } from 'react-redux';
import { wedding1ResultMessageSelector } from '../../../store/slices/Wedding1ResultMessageSlice/Wedding1ResultMessageSlice';
import { customBasesUrlFunc } from '../../../utils/helperFunck';
function Form() {
    const { t, i18n } = useTranslation();
    const [respMessage, setRespMessage] = useState('');
    const [requiredGuest, setRequiredGuest] = useState(false);
    const dispatch = useDispatch()
    const resultMessage = useSelector(wedding1ResultMessageSelector)

    const validationSchema = yup.object().shape({
        name: yup.string().required(t('form.8')),
        guest: yup.string().required(t('form.8'))
        .matches(/[0-9]/, t('form.9')),
        radio_group: requiredGuest ? yup.string().required(t('form.8')) : yup.string()
    });

    const handleRegister = async (e, handleSubmit, isValid, values) => {
        e.preventDefault();
        handleSubmit();
        const params = customBasesUrlFunc()
        values.radio_group === '1' ? setRequiredGuest(true) : setRequiredGuest(false); 

        const obj = {
            token: params?.token,
            guest_name: values.name,
            guest_quantity: values.guest,
            visit: values.radio_group,
        };

      console.log(obj);
      

        if (values.name && values.guest  && isValid) {
          await  dispatch(postWeeding1ResultMessage(obj))
            
        }
    };

    return (
        <div className='form'>
            <Formik
                initialValues={{
                    name: '',
                    guest: '',
                    radio_group: '',
                }}
                onSubmit={(values, { resetForm }) => {
                    resetForm();
                }}
                validateOnBlur
                validationSchema={validationSchema}
            >
                {({ values, errors, touched, handleChange, handleBlur, isValid, handleSubmit, dirty }) => (
                    <form className="register" onSubmit={(e) => handleRegister(e, handleSubmit, isValid, values)}>
                        <div className='full_name_div'>
                            {/* <span>{t('form.0')}</span> */}
                            <div className="name_inp">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder={t('form.1')}
                                    onChange={handleChange}
                                    value={values.name}
                                    onBlur={handleBlur}
                                    autoComplete='off'
                                />
                                {touched.name && errors.name && <p className="error">{errors.name}</p>}
                            </div>
                            <div className="guest_inp">
                                <input
                                    type="text"
                                    name="guest"
                                    placeholder={t('form.10')}
                                    onChange={handleChange}
                                    value={values.guest}
                                    onBlur={handleBlur}
                                    autoComplete='off'
                                />
                                {touched.guest && errors.guest && <p className="error">{errors.guest}</p>}
                            </div>
                           
                        </div>
                        <div className='radio_inp'>
                            <span>{t('form.4')}</span>
                            <div>
                                <input
                                    type='radio'
                                    id="rdo1"
                                    className="radio-input"
                                    name="radio_group"
                                    value="1"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    checked={values.radio_group === "1"}
                                />
                                <label htmlFor="rdo1" className="radio-label">
                                    <span className="radio-border"></span>
                                    {t('form.5')}
                                </label>
                            </div>
                            <div>
                                <input
                                    type='radio'
                                    id="rdo2"
                                    className="radio-input"
                                    name="radio_group"
                                    value="0"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    checked={values.radio_group === "0"}
                                />
                                <label htmlFor="rdo2" className="radio-label">
                                    <span className="radio-border"></span>
                                    {t('form.6')}
                                </label>
                            </div>
                            {touched.radio_group && errors.radio_group && <p className="error">{errors.radio_group}</p>}
                        </div>
                        {resultMessage?.success  && <span className="success">{resultMessage?.message}</span>}
                        <button type='submit' className='register_btn'>{t('form.7')}</button>
                        {respMessage?.success && <span className="success">{t('form.11')}</span>}
                    </form>
                )}
            </Formik>
        </div>
    );
}

export default memo(Form);
